import { gql } from "@apollo/client";

export const getPriorities = gql`
    query getPriorities {
        priority {
            priority_id
            name
            default_priority_translations {
                priority_id
                language {
                    language_id
                    name
                    code
                }
                translated_name
            }
        }
    }
`;
